var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearchPapersActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15371_14978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.875 0.5V4.25H13.625L9.875 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9375 4.25C8.9375 4.76656 9.35844 5.1875 9.875 5.1875H13.625V14.5625C13.625 15.08 13.205 15.5 12.6875 15.5H10.5927L9.02064 13.0748L8.55485 12.9758L8.4236 12.7815C9.14429 12.2322 9.67764 11.4335 9.87941 10.4842C10.3293 8.36755 8.97826 6.28709 6.86156 5.83717C4.93593 5.42786 3.04028 6.50908 2.375 8.30129V1.4375C2.375 0.920937 2.79594 0.5 3.3125 0.5H8.9375V4.25ZM2.375 11.038V14.5625C2.375 15.08 2.79594 15.5 3.3125 15.5H9.07293L7.94824 13.7713L8.04725 13.3055L7.92314 13.1065C7.12817 13.5415 6.1816 13.7039 5.23233 13.5021C3.87218 13.213 2.82817 12.2506 2.375 11.038ZM3.3937 9.10567C3.08164 10.5738 4.01485 12.0108 5.48298 12.3229C6.95111 12.6349 8.38813 11.7017 8.70019 10.2336C9.01225 8.76547 8.07904 7.32845 6.61091 7.01639C5.14278 6.70433 3.70576 7.63754 3.3937 9.10567Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15371_14978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchPapersActive);
export default __webpack_public_path__ + "static/media/researchPapersActive.30a75b66b68088c1e10b81466bd92a88.svg";
export { ForwardRef as ReactComponent };